export default __webpack_public_path__ + "static/media/2020 (3).c4a8ae48.jpg";